import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { MousePositionNotifier } from './mouse-position-notifier';
import { MousePositionState } from './mouse-position-state';

@Injectable()
export class MousePositionProvider extends BaseProvider<MousePositionNotifier, MousePositionState> {
  constructor() {
    super(MousePositionNotifier);
  }
}
